/**
 * CORE-993 — как визард называет продукт, в одном месте.
 *
 * Платная практика и программа — один тип с разным `productType` (так решено на
 * бэке, CORE-994), и общие экраны — это ровно то, ради чего так сделано. Но
 * «общий экран» не значит «общее слово»: у мастера, который продаёт одну
 * практику, шаг 5 спрашивал про готовность программы и обещал опубликовать
 * программу. QA на деве это и отметила — «интерфейс продолжает называть продукт
 * программой».
 *
 * Падежи перечислены руками, а не выводятся: их ровно три, и склонятор ради
 * двух слов был бы дороже самих слов.
 */
import type { MasterProgram, ProgramProductType } from '../../../types/programs';

interface ProductNames {
  /** «Платная практика опубликована» — с большой буквы, начало фразы. */
  nominative: string;
  /** «удалить практику», «опубликовать практику нельзя». */
  accusative: string;
  /** «проверяем готовность практики». */
  genitive: string;
}

const NAMES: Record<ProgramProductType, ProductNames> = {
  program: {
    nominative: 'Программа',
    accusative: 'программу',
    genitive: 'программы',
  },
  paidPractice: {
    // Полное «Платная практика» — там, где продукт называют впервые: в списке
    // рядом лежат оба, и просто «Практика» их не различает. Внутри фразы
    // достаточно «практики» — визард к этому моменту уже про неё.
    nominative: 'Платная практика',
    accusative: 'практику',
    genitive: 'практики',
  },
};

export function productNames(productType: ProgramProductType | undefined): ProductNames {
  return NAMES[productType ?? 'program'] ?? NAMES.program;
}

/** Удобная форма для мест, где под рукой сам продукт, а не его тип. */
export function namesOf(program: Pick<MasterProgram, 'productType'>): ProductNames {
  return productNames(program.productType);
}
